import React, { useEffect, useState } from "react";
import {
  Col,
  InputGroup,
  Row,
  Form as BForm,
  Spinner,
  OverlayTrigger,
  Tooltip,
} from "@themesberg/react-bootstrap";
import { getAdminConfiguration } from "../../utils/apiCalls";
import { BoxContainer, NoDataContainer, UpdateButton } from "./style";
import { InlineLoader } from "../Preloader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDollarSign,
  faInfoCircle,
  faSave,
} from "@fortawesome/free-solid-svg-icons";
import { adminConfigSchema , socialConfigSchema} from "./schema";
import * as Yup from "yup";
import styled from "styled-components";

const AdminConfig = ({ updateData, constant, loading , isSocial, title }) => {
  const [details, setDetails] = useState(null);
  const [isGetLoading, setIsGetLoading] = useState(false);
  const [formValues, setFormValues] = useState({});
  const [originalValues, setOriginalValues] = useState({});
  const [errors, setErrors] = useState({});
  const [updatingFields, setUpdatingFields] = useState({});

  useEffect(() => {
    setIsGetLoading(true);

    async function fetchData() {
      await getAdminConfiguration().then((res) => {
        const adminConfigInfo = res?.data?.data?.result;
        setDetails(adminConfigInfo);

        const initialValues = {};
        constant.forEach(({ value }) => {
          initialValues[value] =
            adminConfigInfo.find((item) => item.key === value)?.value.toString() || "";
        });
        setFormValues(initialValues);
        setOriginalValues(initialValues);

        setIsGetLoading(false);
      });
    }
    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));

    validateField(name, value);
  }



  const validateField = async (fieldName, value) => {
    try {
      let processedValue = value?.trim(); // ✨ TRIM HERE

      if (fieldName !== "WITHDRAWAL_IN_CASH" && fieldName !== "WHATSAPP_NUMBER") {
        processedValue = processedValue === "" ? processedValue : Number(processedValue);
      }

      const data = await Yup.reach(isSocial ? socialConfigSchema : adminConfigSchema, fieldName).validate(processedValue);
      console.log({ processedValue, fieldName, data , adminConfigSchema}, "processsssssssssss")

      setErrors((prev) => ({
        ...prev,
        [fieldName]: null,
      }));

      return true;
    } catch (validationError) {
      console.log({ value, fieldName, validationError , adminConfigSchema}, "processsssssssssss")
      setErrors((prev) => ({
        ...prev,
        [fieldName]: validationError.message,
      }));

      return false;
    }
  };



  const handleSubmit = async (fieldName) => {
    // Set updating state for this field
    setUpdatingFields((prev) => ({
      ...prev,
      [fieldName]: true,
    }));

    try {
      const isValid = await validateField(fieldName, formValues[fieldName]);
      if (!isValid) {
        setUpdatingFields((prev) => ({
          ...prev,
          [fieldName]: false,
        }));
        return;
      }

      const updatePayload = {
        key: fieldName,
        value:
          fieldName === "WITHDRAWAL_IN_CASH"
            ? formValues[fieldName]?.toLowerCase() === 'true'
            : formValues[fieldName],
      };

      await updateData(updatePayload);

      setOriginalValues((prev) => ({
        ...prev,
        [fieldName]: formValues[fieldName],
      }));
    } catch (error) {
      console.error("Error updating field:", error);
    } finally {
      setUpdatingFields((prev) => ({
        ...prev,
        [fieldName]: false,
      }));
    }
  };

  const hasFieldChanged = (fieldName) => {
    return (
      formValues[fieldName]?.toString() !==
      originalValues[fieldName]?.toString()
    );
  };

  const renderFormField = (fieldConfig, index) => {
    const { key, value, info, type, options } = fieldConfig;

    if (type === "select") {
      return (
        <StyledFormSelect
          name={value}
          value={formValues[value] || ""}
          onChange={handleChange}
          isInvalid={!!errors[value]}
        >
          {options?.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </StyledFormSelect>
      );
    }

    return (
      <InputGroup className="flex-grow-1 me-2">
        {key.includes("USD") && (
          <StyledInputGroupText className="bg-white border-primary-subtle">
            <FontAwesomeIcon icon={faDollarSign} />
          </StyledInputGroupText>
        )}
        <StyledFormControl
          type={type || "text"}
          name={value}
          value={formValues[value] || ""}
          onChange={handleChange}
          isInvalid={!!errors[value]}
          isusd={key.includes("USD").toString()}
        />
      </InputGroup>
    );
  };

  return (
    <BoxContainer className="FormsBg">
      <h3 className="mt-2 mb-2"> {title}</h3>
      {isGetLoading ? (
        <NoDataContainer>
          <InlineLoader />
        </NoDataContainer>
      ) : (
        <>
          {details && (
            <Row>
              {constant.map((fieldConfig, index) => {
                const { key, value, info, type } = fieldConfig;

                return (
                  <Col md={6} sm={12} className="mb-4" key={index}>
                    <div className="field-container p-3 border rounded bg-white shadow-sm">
                      <BForm.Label className="form-label mb-2 d-flex align-items-center">
                        <span className="fw-bold text-primary">
                          {key || "N/A"}
                        </span>
                        {info && (
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip id={`tooltip-${index}`}>{info}</Tooltip>
                            }
                          >
                            <span className="ms-2">
                              <FontAwesomeIcon
                                icon={faInfoCircle}
                                className="text-warning"
                              />
                            </span>
                          </OverlayTrigger>
                        )}
                      </BForm.Label>

                      <div className="d-flex align-items-center">
                        {type === "select" ? (
                          <div className="flex-grow-1 me-2">
                            {renderFormField(fieldConfig, index)}
                          </div>
                        ) : (
                          renderFormField(fieldConfig, index)
                        )}

                        <UpdateButton
                          hasChanges={hasFieldChanged(value)}
                          disabled={
                            updatingFields[value] ||
                            !!errors[value] ||
                            !hasFieldChanged(value)
                          }
                          onClick={() => handleSubmit(value)}
                          type="button"
                        >
                          {updatingFields[value] ? (
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                          ) : (
                            <>
                              <FontAwesomeIcon icon={faSave} className="me-2" />
                              Update
                            </>
                          )}
                        </UpdateButton>
                      </div>

                      {errors[value] && (
                        <div className="text-danger mt-1 small">
                          {errors[value]}
                        </div>
                      )}
                    </div>
                  </Col>
                );
              })}
            </Row>
          )}
        </>
      )}
    </BoxContainer>
  );
};

export default AdminConfig;

const StyledFormControl = styled(BForm.Control)`
  border-radius: ${(props) =>
    props.isusd === "true" ? "0 0.3rem 0.3rem 0" : "0.3rem"} !important;
  border-color: #d1d7e0 !important;

  &:focus {
    box-shadow: none !important;
    border-color: rgb(132, 0, 255) !important;
  }
`;

const StyledFormSelect = styled(BForm.Select)`
  border-radius: 0.3rem !important;
  border-color: #d1d7e0 !important;

  &:focus {
    box-shadow: none !important;
    border-color: rgb(132, 0, 255) !important;
  }
`;

const StyledInputGroupText = styled(InputGroup.Text)`
  border-radius: 0.3rem 0 0 0.3rem !important;
`;
